import { render } from "./main-page.vue?vue&type=template&id=9617857e&scoped=true"
import script from "./main-page.js?vue&type=script&lang=js&external"
export * from "./main-page.js?vue&type=script&lang=js&external"

import "./main-page.vue?vue&type=style&index=0&id=9617857e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9617857e"]])

export default __exports__